import { IAuditLogPayload } from "hooks/use-audit-log";

import { BaseApi } from "../base";

export default class AuditLogApi extends BaseApi {
  protected readonly prefix = "auditLog";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAuditLog = (payload: IAuditLogPayload) => this.get("", payload);
}
